import { CUSTOMER_JOURNEY_HOTEL, CUSTOMER_JOURNEY_HOTEL_SUCCESS, CUSTOMER_JOURNEY_HOTEL_ERROR } from './../../actions/const';
import { SET_TOKEN, SET_LANG } from './../../actions/const';

import CustomerJourneySource from './../../sources/CustomerJourneySource';
import history from './../../stores/history';

import defer from 'lodash/defer';

const DEFAULT_TEMPLATE = "BWCore";

const initialState = {
  apiData: {
    template: DEFAULT_TEMPLATE
  },
  loading: false
};

function reducer(state = initialState, action) {

  const nextState = Object.assign({}, state);

  switch (action.type) {
    case SET_TOKEN:
    case SET_LANG:
    case CUSTOMER_JOURNEY_HOTEL: {
      nextState.loading = true;
      CustomerJourneySource.hotel(action.token, action.lang, action.context);
      return nextState;
    }
    case CUSTOMER_JOURNEY_HOTEL_SUCCESS: {
      nextState.loading = false;
      nextState.apiData = action.data;
      return nextState;
    }
    case CUSTOMER_JOURNEY_HOTEL_ERROR: {
      nextState.loading = false;
      nextState.apiData = {
        template: DEFAULT_TEMPLATE
      };

      // Go to Error Page
      defer(()=>{
        history.push('/');
      });

      return nextState;
    }
    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/hotel.js